var angular = require('angular');
var _module = require('../../components/module');

// Services
_module.factory('$lrTouchStart', [
    '$log',

    function $lrTouchStartFactory($log) {
        return function $lrTouchStart(elem, cb) {
            var touched = false;

            elem.on('touchstart', ontouchstart);
            angular.element(document.getElementsByTagName('body')).on('mousedown', onmousedown);

            // Functions
            function ontouchstart(e) {
                touched = true;

                if(cb) cb(e, { pageX: getPageX(e), pageY: getPageY(e) });

                elem.on('touchstart', onup);
                angular.element(document.getElementsByTagName('body')).on('mouseup', onup);
            }

            function onmousedown(e) {
                if(e.target == elem[0] && !touched) {
                    ontouchstart(e);
                }
            }

            function onup() {
                touched = false;

                elem.off('touchend', onup);
                angular.element(document.getElementsByTagName('body')).off('mouseup', onup);
            }

            return elem;
        };
    }
]);

_module.factory('$lrTouchEnd', [
    '$log',

    function $lrTouchEndFactory($log) {
        return function $lrTouchEnd(elem, cb) {
            elem.on('touchend', ontouchend);
            angular.element(document.getElementsByTagName('body')).on('mouseup', ontouchend);

            // Functions
            function ontouchend(e) {
                if(cb) cb(e);

                elem.off('touchmove touchend');
                angular.element(document.getElementsByTagName('body')).off('mousemove mouseup');
            }

            return elem;
        };
    }
]);

_module.factory('$lrTouchMove', [
    '$log',

    function $lrTouchMoveFactory($log) {
        return function $lrTouchMove(elem, cb) {
            elem.on('touchmove', ontouchmove);
            angular.element(document.getElementsByTagName('body')).on('mousemove', ontouchmove);

            // Functions
            function ontouchmove(e) {
                if(cb) cb(e, { pageX: getPageX(e), pageY: getPageY(e) });
            }

            return elem;
        };
    }
]);

_module.factory('$lrDrag', [
    '$log',
    '$timeout',
    '$parse',

    function $lrdragFactory($log, $timeout) {
        return function $lrDrag(elem, options) {
            options = options || {};

            var maxDragX = options.maxDragX || null;
            var startX = null;
            var currentPositionX = 0;

            $timeout(function lrdragtimeout() {
                maxDragX = maxDragX || elem.parent()[0].offsetWidth;
            }, 10);

            elem.on('touchstart', ontouchstart);
            angular.element(document.getElementsByTagName('body')).on('mousedown', onmousedown);

            // Functions
            function ontouchstart(e) {
                e.preventDefault();

                startX = elem.parent()[0].getBoundingClientRect().left;

                elem.on('touchmove', ontouchmove);
                elem.on('touchend', ontouchend);
                angular.element(document.getElementsByTagName('body')).on('mousemove', ontouchmove);
                angular.element(document).on('mouseup', ontouchend);
            }

            function ontouchmove(e) {
                e.preventDefault();

                var posX = Math.round(getPageX(e) - startX);

                if(posX < 0) {
                    posX = 0;
                } else if(posX > maxDragX) {
                    posX = maxDragX;
                }

                currentPositionX = posX;
                elem.triggerHandler('lrtouch-draging', { x: currentPositionX, maxDragX: maxDragX, percentX: (currentPositionX / maxDragX * 100) / 100 });
            }

            function ontouchend() {
                elem.off('touchmove', ontouchmove);
                angular.element(document.getElementsByTagName('body')).off('mousemove', ontouchmove);
                elem.off('touchend', ontouchend);
                angular.element(document).off('mouseup', ontouchend);

                elem.triggerHandler('lrtouch-dragend', { x: currentPositionX, maxDragX: maxDragX, percentX: (currentPositionX / maxDragX * 100) / 100 });
            }

            function onmousedown(e) {
                if(e.target == elem[0]) {
                    ontouchstart(e);
                }
            }

            return elem;
        };
    }
]);

_module.factory('$lrTap', [
    '$log',
    '$timeout',

    function $lrtapFactory($log, $timeout) {
        var elementsWatching = [];

        return function $lrTap(elem) {
            var distanceThreshold = 25;
            var timeThreshold = 500;
            var tapped = false;
            var dragged = false;
            var target = null;
            var startX = null;
            var startY = null;

            if(~elementsWatching.indexOf(elem)) return elem;

            elementsWatching.push(elem);

            elem.on('touchstart', ontouchstart);
            elem.on('click', onmouseclick);

            // Functions
            function ontouchstart(e) {
                startX = getPageX(e);
                startY = getPageY(e);
                tapped = false;
                target = e.target;

                $timeout(removetaphandler, timeThreshold);
                elem.on('touchmove', movehandler);
                elem.on('touchend', taphandler);
            }

            function taphandler(e) {
                e.preventDefault();
                removetaphandler();

                if(target == e.target) {
                    tapped = true;

                    elem.triggerHandler('tap', angular.element(e.currentTarget));
                }
            }

            function movehandler(e) {
                var moveX = getPageX(e);
                var moveY = getPageY(e);

                if(
                    Math.abs(moveX - startX) > distanceThreshold ||
                    Math.abs(moveY - startY) > distanceThreshold
                ) {
                    tapped = true;

                    removetaphandler();
                }
            }

            function removetaphandler() {
                $timeout.cancel();
                elem.off('touchmove', movehandler);
                elem.off('touchend', taphandler);
            }

            function onmouseclick(e) {
                if(!(tapped || dragged)) {
                    elem.triggerHandler('tap', angular.element(e.currentTarget));
                }
            }

            return elem;
        };
    }
]);


// Directives
_module.directive('lrDrag', [
    '$log',
    '$parse',
    '$lrDrag',

    function lrDragDirective($log, $parse, $lrDrag) {
        return function lrDrag($scope, elem, attrs) {
            var fn = $parse(attrs.onDrag);
            $lrDrag(elem).on('lrtouch-draging lrtouch-dragend', ondragend);

            function ondragend(e, data) {
                $scope.$apply(function touchApply() {
                    elem.css('left', (data.x || 0) + 'px');

                    if(attrs.onDrag) {
                        fn($scope, { $event: data });
                        $scope.$applyAsync();
                    }
                });
            }
        };
    }
]);

_module.directive('lrTap', [
    '$log',
    '$lrTap',
    '$parse',

    function lrTapDirective($log, $lrTap, $parse) {
        return function lrTap($scope, elem, attrs) {
            var fn = $parse(attrs['lrTap']);
            $lrTap(elem).on('tap', ontap);

            function ontap(e) {
                $log.debug('lrTap -> ontap', attrs['lrTap']);

                fn($scope, { $event: e });
                $scope.$applyAsync();
            }
        };
    }
]);

_module.directive('ngTap', [
    '$log',
    '$lrTap',
    '$parse',

    function lrTapDirective($log, $lrTap, $parse) {
        return function lrTap($scope, elem, attrs) {
            var fn = $parse(attrs['ngTap']);
            $lrTap(elem).on('tap', ontap);

            function ontap(e) {
                $log.debug('ngTap -> ontap', attrs['ngTap'], arguments);

                fn($scope, { $event: e });
                $scope.$applyAsync();
            }
        };
    }
]);

// Helper Functions
function getPageX(e) {
    if(e.originalEvent) {
        return e.originalEvent.touches[0].pageX;
    } else {
        return e.pageX || e.touches[0].pageX || e.changedTouches[0].pageX;
    }
}

function getPageY(e) {
    if(e.originalEvent) {
        return e.originalEvent.touches[0].pageY;
    } else {
        return e.pageY || e.touches[0].pageY || e.changedTouches[0].pageY;
    }
}
